import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import { BsHouseAddFill } from 'react-icons/bs';
import React, { useState } from 'react';
import { useSchedulerStore } from '../../stores/SchedulerStore';
import { PatientAddress } from '@revival/scheduler';
import { StateSelect } from './StateSelect';
import useToken from '../../hooks/useToken';

export const AddNewAddressButton = () => {
  const { token } = useToken();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const addNewPatientAddress = useSchedulerStore(
    (state) => state.addNewPatientAddress,
  );
  const reminder = useSchedulerStore((state) => state.reminder);
  const [isSaving, setIsSaving] = useState(false);
  const [address, setAddress] = useState<Partial<PatientAddress>>({
    label: '',
    street: '',
    city: '',
    state: 'AZ',
    zip: '',
  });

  const saveNewAddress = async () => {
    if (reminder) {
      setIsSaving(true);

      const { success, data } = await addNewPatientAddress(
        reminder.patient.id,
        address,
        token,
      );

      if (success) {
        onClose();
      } else {
        setIsSaving(false);
        //TODO: display error message
      }
    }
    setIsSaving(false);
  };

  const onChange = (e: any) => {
    const field = e.target.id;
    setAddress({ ...address, [field]: e.target.value });
  };

  return (
    <>
      <Box
        w={{ base: '90%', lg: '75%' }}
        pl={2}
        py={2}
        border={'1px solid'}
        borderColor={'var(--chakra-colors-chakra-border-color)'}
        borderRadius={5}
        onClick={onOpen}
        cursor={'pointer'}
        color={'messenger.300'}
        _hover={{ color: 'messenger.500' }}
      >
        <Flex ml={'25%'} alignItems={'center'}>
          <Box mx={3}>
            <BsHouseAddFill size={30} />
          </Box>
          <Text userSelect={'none'}>Add New</Text>
        </Flex>
      </Box>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered={true}
        size={{ base: 'full', lg: 'md' }}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add New Address</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack>
              <FormControl>
                <FormLabel>Label</FormLabel>
                <Input
                  id={'label'}
                  type="text"
                  placeholder={'Home, Office, etc.'}
                  value={address.label}
                  onChange={onChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Street</FormLabel>
                <Input
                  id={'street'}
                  type="text"
                  value={address.street}
                  onChange={onChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>City</FormLabel>
                <Input
                  id={'city'}
                  type="text"
                  value={address.city}
                  onChange={onChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>State</FormLabel>
                <StateSelect
                  id={'state'}
                  value={address.state}
                  onChange={onChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Zip Code</FormLabel>
                <Input
                  id={'zip'}
                  type="number"
                  pattern="\d*"
                  value={address.zip}
                  onChange={onChange}
                />
              </FormControl>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              onClick={saveNewAddress}
              isLoading={isSaving}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
